import React from 'react'
import { Navigate, Route, Routes } from "react-router-dom";
import TutorRoute from '../route/TutorRoute';
import TutorRouter from './TutorRouter';

const PublicRouterNew = () => {
  return (
   <Routes>
      <Route
              path="tutor/*"
              element={
                <TutorRoute>
                  <TutorRouter />
                </TutorRoute>
              }
            />

   </Routes>
  )
}

export default PublicRouterNew